import React from 'react';
import { BsArrowLeftCircleFill, BsFillCursorFill, BsFillXCircleFill } from 'react-icons/bs';
import { NavLink } from 'react-router-dom';
import { Server } from '../../server/server';
import { getPortraitImage, urlToLink } from '../util/util';
import './ChatPage.css'

interface ChatPageState {
  input: string;
  loading: boolean,
}

class ChatPage extends React.Component<{}, ChatPageState> {
  protected chatId: string;
  protected messagesDiv: React.RefObject<HTMLDivElement>;
  protected updatingChats: boolean;

  constructor(props:{}) {
    super(props);
    this.state = {
      input: '',
      loading: false
    }

    this.chatId = window.location.pathname.substring(6);
    this.updatingChats = false;

    this.messagesDiv = React.createRef();
    this.onInputChange = this.onInputChange.bind(this);
    this.onClose = this.onClose.bind(this);
    this.onSendMessage = this.onSendMessage.bind(this);
    this.onChatUpdated = this.onChatUpdated.bind(this);
    this.onInputKeyDown = this.onInputKeyDown.bind(this);
  }

  componentDidMount(): void {
    Server.messages.addEventListener('chat-updated', this.onChatUpdated);
    this.loadChat();
  }

  componentDidUpdate(): void {
    this.messagesDiv.current.scrollTop = this.messagesDiv.current.scrollHeight;
  }

  componentWillUnmount() {
    Server.messages.removeEventListener('chat-updated', this.onChatUpdated);
  }

  clearUpdatedChats() {
    this.updatingChats = true;
    Server.messages.clearChatUpdated(this.chatId);
    this.updatingChats = false;
  }

  onChatUpdated(data:any) {
    if(data.chat == this.chatId && !this.updatingChats) {
      this.clearUpdatedChats();
      this.forceUpdate();
    }
  }

  async loadChat() {
    this.setState({loading: true});
    await Server.messages.getChatMessages(this.chatId);
    this.clearUpdatedChats();
    this.setState({loading: false});
  }

  onInputChange(e:any) {
    this.setState({input: e.target.value});
  }

  onInputKeyDown(e: any): void {
    if (e.key === 'Enter')
      this.onSendMessage();
  };

  async onSendMessage() {
    if (!this.state.input.trim()) 
      return;

    Server.messages.sendChatMessage(this.chatId, this.state.input).then((response:any)=>{
      if(!response.success)
        this.forceUpdate();
    });

    this.setState({input: ''});
  }

  onClose() {
  }

  renderMessages() {
    if(this.state.loading) 
      return (<div>Loading messages...</div>)

    let chat = Server.messages.getChat(this.chatId);
    
    let messages:any[] = [];

    if(!chat.messages)
      return messages;

    for (let i = 0; i < chat.messages.length; i++) {
      let msg          = chat.messages[i];
      let message      = urlToLink(msg.message);
      let msgDate      = new Date(msg.date);
      let now          = new Date();
      let elapsedHours = (now.getTime() - msgDate.getTime())/1000/60/60;

      let time = '';
      if(chat.messages[i].failed)
        time = 'FAILED TO SEND';
      else if(elapsedHours > 12)
        time = new Date(msg.date).toLocaleString();

      let className = 'chat-message-sender'
      if(msg.user == Server.user.getId())
        className = 'chat-message-myself';

      let marginTop = '5px';
      if(i > 0 && chat.messages[i-1].user != msg.user)
        marginTop = '15px';
      
      messages.push(
        <div key={i} style={{marginTop: marginTop}}>
          <div className={className}>
            <div className={className+'-text'} dangerouslySetInnerHTML={message} />
          </div>
          {time != '' &&
            <div className={className}>
              <div className={className+'-time'}>{time}</div>
            </div>
          }
        </div>
      )
    }

    return messages;
  }

  render() {
    let chat = Server.messages.getChat(this.chatId);
    let profile = Server.public.getProfile(chat.user);

    return (
      <div className="chat-page">
        <div className="chat-page-content">
          <div className="chat-page-header">
            <div style={{display: 'flex', alignItems: 'center', columnGap: '10px'}}>
              <img className="chat-page-header-portrait" src={getPortraitImage(profile)} />
              {profile.name}
            </div>
            <NavLink className="chat-page-header-close" to={-1 as any}>
              <BsArrowLeftCircleFill />
            </NavLink>
          </div>
          <div className="chat-page-messages" ref={this.messagesDiv}>
            {this.renderMessages()}
          </div>
          <div className="chat-page-footer">
            <input className="chat-page-input" value={this.state.input} onChange={this.onInputChange} onKeyDown={this.onInputKeyDown} />
            <button className="chat-page-send-button" onClick={this.onSendMessage}><BsFillCursorFill size={20}/></button>
          </div>
        </div>
      </div>
    );
  }
}

export default ChatPage;
